import React from 'react';
import { createRoot } from 'react-dom/client';
import "./index.scss"
// import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import {BrowserRouter as Router} from "react-router-dom";
import RouterComponent from "./components/RouterComponent";
import './i18n';
// import StartComponent from "./components/StartComponent";
// import MyLoginComponent from "./components/MyLoginComponent";
// import { OAuthPopup } from "@tasoskakour/react-use-oauth2";

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Router>
    <RouterComponent />
</Router>);
// root.render(<Router>
//     <Routes>
//         <Route>
//             <Route path={"/:lang/:confType/"} element={<StartComponent/>}/>
//             <Route path={"/:lang/:confType/myjung"} element={<MyLoginComponent/>}/>
//             <Route path={"/:lang/:confType/myjung/callback"} element={<OAuthPopup/>}/>
//             <Route path={"/:lang/:confType/myjung/:code"} element={<MyLoginComponent/>}/>
//             <Route path={"/:lang/:confType/:code"} element={<StartComponent/>}/>
//         </Route>
//         <Route path={"/:confType/myjung/callback"} element={<OAuthPopup/>}/>
//     </Routes>
// </Router>);

